function moneyBR( v ) {
    v = v.replace(/\D/g,"")
    v = v.replace(/(\d{2})$/,",$1")

    v = v.replace(/(\d+)(\d{3},\d{2})$/g,"$1.$2")
    
    var qtdLoop = (v.length-3)/3;
    var count = 0;
    while (qtdLoop > count) {
        count++;
        v = v.replace(/(\d+)(\d{3}.*)/,"$1.$2")
    }
    
    v = v.replace(/^(0)(\d)/g,"$2")
                
    return v
}

function money( v ) {
    v = v.replace(/\D/g,"")
    v = v.replace(/(\d{2})$/,".$1")

    v = v.replace(/(\d+)(\d{3},\d{2})$/g,"$1,$2")
    
    var qtdLoop = (v.length-3)/3;
    var count = 0;
    while (qtdLoop > count) {
        count++;
        v = v.replace(/(\d+)(\d{3}.*)/,"$1,$2")
    }
    
    v = v.replace(/^(0)(\d)/g,"$2")
                
    return v
}

function decimal(v) {
    v = v.replace(/\D/g,"")
    v = v.replace(/(\d+)(\d{2})/, "$1.$2")
    return v
}

export default (evt, mask, callback) => {

    var src = evt.target
    src.value = src.value.replace(/[^\d]+/g,'')

    if(mask === 'money') {
        src.value = money(src.value)
        callback(evt)
        return
    }

    if(mask === 'money_br') {
        src.value = moneyBR(src.value)
        callback(evt)        
        return
    }

    if(mask === 'decimal') {
        src.value = decimal(src.value)
        callback(evt)        
        return
    }

    var ic = 0
    var value = ''
    
    for (var i = 0; i < mask.length; ++i) {
        const c = src.value.charAt(ic)
        const m = mask.charAt(i)

        if(c === '') break
        
        if(m !== '#') {
            value += m
        } else {          
            value += c
            ic++
        }
    }

    src.value = value
    callback(evt)
    
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Form/mask.js